import { Autocomplete, SxProps, TextField, Theme } from "@mui/material";



interface MultiworldPlayerAutocompleteProps {
    data: Array<string>
    label?: string,
    additionalOnChange?: (value: string | null) => void,
    selection?: string | null
    sx?: SxProps<Theme>
}

export const MultiworldPlayerAutocomplete = (params: MultiworldPlayerAutocompleteProps) => {

    let { data } = params;

    return <Autocomplete
        options={data}
        renderInput={(props) => <TextField {...props}  label={params.label} multiline sx={{ textAlign: "center", width: "150px" }} variant="standard" />}
        getOptionLabel={(o) => o}
        fullWidth
        sx={{ ...params.sx,  }}
        size='small'
        onChange={(e, v) => { params.additionalOnChange?.(v) }}
        value={params.selection}
        
    />
}
